/** @module csi/widget/_svg/Print */
define([
	"dijit/form/ComboButton",
	"dijit/Menu",
	"dijit/MenuItem",
	"csi/locale",
	"csi/xml",
	"./_Plugin",
	"./PluginFactory"
], function(ComboButton,Menu,MenuItem,locale,xml,_Plugin,PluginFactory) {

	return PluginFactory.declare([ComboButton, _Plugin], {
		iconClass: "csiActionIcon iconPrint",
		pluginName: "print",
		title: "ViewPrint_TT",

		/**
		 * Only show plugin when not in edit mode
		 * @return {boolean}
		 */
		canShowPlugin: function() {
			return !this.editor.editMode;
		},

		/**
		 * Regenerate snapshots if any are missing and print view.
		 */
		onClick: function() {
			const {view} = this.editor;
			if (view.isMissingSnapshots()) {
				view.regenerateSnapshots(() => view.print());
			} else {
				view.print();
			}
		},

		startup: function () {
			if (this._started) {
				return;
			}

			this.dropDown = new Menu();
			this.dropDown.addChild(new MenuItem({
				label: locale.resource("ViewPrintPreview"),
				onClick: (e) => {
					const {view} = this.editor;
					if (view.isMissingSnapshots()) {
						view.regenerateSnapshots(() => view.print(true));
					} else {
						view.print(true);
					}
				}
			}));

			this.inherited(arguments);
		}
	});
});